import { createContext } from 'react';

export const highlightListContext = createContext<string[]>([]);
